import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { headerStyles } from "../../styles/styles";
import CustomFilterTabs from "../../../../Components/CustomFilterTabs";
import { useTranslation } from "react-i18next";

const MembersHeader = (props) => {
  const { activeTab, setActiveTab, searchValue, setSearchValue, memberStats } =
    props;

  const { t } = useTranslation("page-my-community-members");

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={headerStyles.container}>
      <CustomFilterTabs
        tabs={[
          {
            label: t('table_tabs.community_members'),
            count: memberStats.communityMembersStat,
            value: 1
          },
          {
            label: t('table_tabs.join_requests'),
            count: memberStats.communityRequestsStat,
            value: 2,
          },
        ]}
        activeTab={activeTab}
        onChange={handleTabChange}
      />

      <Box sx={headerStyles.searchContainer}>
        <TextField
          value={searchValue}
          onChange={(e) => {
            const value = e.target.value;
            setSearchValue(value);
          }}
          variant="outlined"
          placeholder={t('search')}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: searchValue && (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => {
                    setSearchValue("");
                  }}
                  size="small"
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{
            ...headerStyles.searchInput,
            fontSize: "15px",
            color: "rgba(62, 63, 76, 0.7)",
            borderRadius: "8px",
            backgroundColor: "#ffffff",
            "& fieldset": {
              borderWidth: "1px",
              borderColor: "#EAEAEA",
            },
            "&:hover fieldset": {
              borderWidth: "1px",
              borderColor: "#3e3f4c",
            },
            "&.Mui-focused fieldset": {
              borderWidth: "1px",
              borderColor: "#3e3f4c",
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default MembersHeader;
